"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@dynamynd/core");

var responsive_1 = require("@dynamynd/responsive");

var utilities_1 = require("@dynamynd/utilities");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var redux_1 = require("redux");

var styled_components_1 = __importStar(require("styled-components"));

var ContentContainerScrollable = styled_components_1.default(function (_a) {
  var height = _a.height,
      activeBreakpoint = _a.activeBreakpoint,
      scroll = _a.scroll,
      rest = __rest(_a, ["height", "activeBreakpoint", "scroll"]);

  return react_1.default.createElement(react_native_1.ScrollView, __assign({
    ref: scroll
  }, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    ", "\n"], ["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      height = _a.height,
      theme = _a.theme;
  var small = responsive_1.isSmall(activeBreakpoint);
  var gutterSize = small ? core_1.GutterSizeEnum.small : core_1.GutterSizeEnum.wide;
  var headerHeight = small ? theme.view.logo.small.height : theme.view.logo.large.height;
  var footerHeight = small ? 0 : theme.typography.link.lineHeight;
  return "\n            padding-top: " + (small && height > 640 ? '30px' : 0) + ";\n            height: " + utilities_1.calculateHeight(height, gutterSize, headerHeight, footerHeight) + "px;\n        ";
});
var hoc = redux_1.compose(responsive_1.withResponsiveMeta, styled_components_1.withTheme);
exports.default = hoc(ContentContainerScrollable);
var templateObject_1;